import CardDefault from "components/Cards/CardDefault/index";
import NewTable from "components/NewTable";
import useHistoricoCobrancaColumns from "./hooks/useHistoricoCobrancaColumns";
import PrimaryButton from "components/Button/PrimaryButton";
import { Box } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import ModalNovaCobranca from "components/ModalHistoricoCobranca/ModalHistoricoCobranca";
import useHistoricoCobranca from "features/cobranca/hooks/useHistoricoCobranca";
import useDetalhesCobranca from "core/features/cobranca/hooks/useDetalhesCobranca";
import moment from "moment";

interface HistoricoCobrancaProps {
  unidadeId: string;
  tenantId: string;
}

export default function HistoricoCobranca({
  unidadeId,
  tenantId,
}: HistoricoCobrancaProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const columns = useHistoricoCobrancaColumns();
  const [dados] = useState<moment.Moment | null>(moment());
  const { data, isLoading, isFetching } = useHistoricoCobranca(unidadeId);
  const [historicoEditId, setHistoricoEditId] = useState<string | undefined>();
  const { data: detalhesCobranca } = useDetalhesCobranca(
    unidadeId,
    dados?.format("YYYY-MM-DD") || moment().format("YYYY-MM-DD")
  );

  useEffect(() => {
    if (historicoEditId) {
      setIsOpenModal(true);
    }
  }, [historicoEditId]);

  useEffect(() => {
    if (!isOpenModal) {
      setHistoricoEditId(undefined);
    }
  }, [isOpenModal]);

  return (
    <CardDefault mb={8} bg="white" p="16px">
      <Box w="100px" mb={4}>
        <PrimaryButton onClick={() => setIsOpenModal(true)}>
          Registrar Histórico
        </PrimaryButton>
      </Box>

      <NewTable
        loading={isLoading || isFetching}
        columns={columns}
        dataSource={data}
        actions={[
          {
            title: "Editar",
            onClick: (v) => setHistoricoEditId(v.id),
          },
        ]}
      />
      {isOpenModal ? (
        <ModalNovaCobranca
          tenantId={tenantId}
          unidadeId={unidadeId}
          pessoaId={detalhesCobranca?.proprietario?.id!}
          historicoId={historicoEditId}
          isOpen={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSaved={() => {
            setIsOpenModal(false);
          }}
        />
      ) : null}
    </CardDefault>
  );
}
